import { request } from '../../helpers/api/request';
import { UsersCardContractParams } from '../../types/Endpoints/UsersCardContract';

export const deleteUser = async (params: UsersCardContractParams) => {
    const { data } = await request({
        url: `users/${params.id}`,
        method: 'DELETE',
    });

    return data;
};
